/* Clergy cart — drawer + cart page.
 *
 * Exposes window.clgCart:
 *   open() / close()          — the drawer
 *   change(key, qty)          — update a line
 *   add(items)                — add to cart, then open the drawer
 *
 * Cart AJAX endpoints accept a `sections` param and return re-rendered Liquid for them,
 * so one request both mutates the cart and gives us fresh markup. That keeps prices,
 * currency and discounts rendered by Liquid — never recalculated in JS.
 */
(function () {
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function sectionEls() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-clg-cart-section]'));
  }
  function sectionIds() {
    return sectionEls().map(function (el) { return el.dataset.clgCartSection; }).filter(Boolean);
  }

  // Swap each section's contents with the freshly rendered HTML.
  function applySections(sections) {
    if (!sections) return;
    sectionEls().forEach(function (el) {
      var html = sections[el.dataset.clgCartSection];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-clg-cart-contents]');
      var live = el.querySelector('[data-clg-cart-contents]');
      if (fresh && live) live.innerHTML = fresh.innerHTML;
    });
    updateCount();
  }

  // Keep the header's "Cart (n)" honest without a page reload.
  function updateCount() {
    fetch(routes + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update just the count span (desktop label) and the mobile badge — never the whole
        // link, or the mobile cart icon inside it would be wiped out.
        document.querySelectorAll('[data-clg-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('[data-clg-cart-bub]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('clg:cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  function drawer() { return document.querySelector('[data-clg-drawer]'); }
  function scrim() { return document.querySelector('[data-clg-cart-scrim]'); }

  function open() {
    var d = drawer(); if (!d) return;
    d.classList.add('open');
    if (scrim()) scrim().classList.add('show');
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-clg-drawer-close]');
    if (close) close.focus();
  }
  function close() {
    var d = drawer(); if (!d) return;
    d.classList.remove('open');
    if (scrim()) scrim().classList.remove('show');
    document.body.style.overflow = '';
  }

  function post(url, body) {
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;
    return fetch(routes + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        applySections(data.sections);
        // Nothing left to re-render into on the cart page — reload for the empty state.
        if (data.item_count === 0 && document.querySelector('[data-clg-cart-page]')) window.location.reload();
        return data;
      });
  }

  /* A garment and the services bought with it (tailoring, embroidery) share a hidden
     _clg_group token. Changing or removing the garment must carry them along — otherwise
     you can end up paying a tailoring fee for a robe that's no longer in the cart. */
  function change(key, qty) {
    var line = document.querySelector('[data-clg-line-key="' + key + '"]');
    if (line) line.classList.add('is-loading');

    var group = line && line.dataset.clgGroup;
    var isChild = line && line.hasAttribute('data-clg-child');

    if (group && !isChild) {
      var updates = {};
      document.querySelectorAll('[data-clg-group="' + group + '"]').forEach(function (el) {
        el.classList.add('is-loading');
        updates[el.dataset.clgLineKey] = qty;
      });
      return post('cart/update.js', { updates: updates })
        .catch(function () { document.querySelectorAll('.is-loading').forEach(function (el) { el.classList.remove('is-loading'); }); });
    }

    return post('cart/change.js', { id: key, quantity: qty })
      .catch(function () { if (line) line.classList.remove('is-loading'); });
  }

  function add(items) {
    return fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionIds().join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }

  // Delegated: survives the innerHTML swaps above without rebinding.
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-clg-cart-qty]');
    if (q) { e.preventDefault(); change(q.dataset.key, parseInt(q.dataset.qty, 10)); return; }
    if (e.target.closest('[data-clg-drawer-close]') || e.target.closest('[data-clg-cart-scrim]')) { close(); return; }
    if (e.target.closest('[data-clg-cart-open]')) { e.preventDefault(); open(); }
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-clg-cart-input]');
    if (i) change(i.dataset.key, Math.max(0, parseInt(i.value, 10) || 0));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* A focused input[type=number] spins on wheel, so scrolling the cart past a quantity
     field silently ratchets it. Blur on wheel: the page scrolls, the number doesn't. */
  document.addEventListener('wheel', function (e) {
    var i = e.target.closest && e.target.closest('input[type="number"]');
    if (i && document.activeElement === i) i.blur();
  }, { passive: true });

  window.clgCart = { open: open, close: close, change: change, add: add, applySections: applySections };
})();
